import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IFollowUpTaskNote } from "../../utils/types/models";

export default createEntityReducer<IFollowUpTaskNote>(Endpoint.FollowUpTaskNotes, Endpoint.FollowUpTaskNotesList);
